export const MAPPING_FIELD_NAMES = {
  MOS_PROCESSED_FILE_NAME: 'MOS Processed File Name',
  ENCOMPASS_EFOLDER_NAME: 'Encompass eFolder Name',
  MOS_DOCUMENT_TYPE_NAME: 'MOS Document Type Name',
  MOS_TENANT_DOCUMENT_TYPE_DISPLAY_NAME:
    'MOS Tenant Document Type Display Name',
  MOS_EXTRACTED_FIELD_NAME: 'MOS Extracted Field Name',
  MOS_TENANT_FIELD_DISPLAY_NAME: 'MOS Tenant Field Display Name',
  STATUS: 'Status',
  SOURCE_FIELD_ID: 'Source Field ID',
  MOS_EXTERNAL_FIELD_NAME: 'MOS External Field Name',
  SOURCE: 'Source',
  SCOPE: 'Scope',
} as const;

export const MAPPINGS_CSV_HEADERS = [
  MAPPING_FIELD_NAMES.MOS_PROCESSED_FILE_NAME,
  MAPPING_FIELD_NAMES.ENCOMPASS_EFOLDER_NAME,
  MAPPING_FIELD_NAMES.MOS_DOCUMENT_TYPE_NAME,
  MAPPING_FIELD_NAMES.MOS_TENANT_DOCUMENT_TYPE_DISPLAY_NAME,
  MAPPING_FIELD_NAMES.MOS_EXTRACTED_FIELD_NAME,
  MAPPING_FIELD_NAMES.MOS_TENANT_FIELD_DISPLAY_NAME,
  MAPPING_FIELD_NAMES.SOURCE,
  MAPPING_FIELD_NAMES.SOURCE_FIELD_ID,
  MAPPING_FIELD_NAMES.MOS_EXTERNAL_FIELD_NAME,
  MAPPING_FIELD_NAMES.SCOPE,
] as const;

export const LIBRARY_CSV_HEADERS = [
  ...MAPPINGS_CSV_HEADERS.slice(0, 6),
  MAPPING_FIELD_NAMES.STATUS,
  ...MAPPINGS_CSV_HEADERS.slice(6),
] as const;

// Fields that propagate changes to matching rows
export const PROPAGATE_FIELDS = [
  MAPPING_FIELD_NAMES.MOS_PROCESSED_FILE_NAME,
  MAPPING_FIELD_NAMES.ENCOMPASS_EFOLDER_NAME,
  MAPPING_FIELD_NAMES.MOS_DOCUMENT_TYPE_NAME,
  MAPPING_FIELD_NAMES.MOS_TENANT_DOCUMENT_TYPE_DISPLAY_NAME,
] as const;

// Fields that are required and cannot be empty
export const REQUIRED_EDITABLE_FIELDS = [
  MAPPING_FIELD_NAMES.MOS_DOCUMENT_TYPE_NAME,
  MAPPING_FIELD_NAMES.MOS_TENANT_DOCUMENT_TYPE_DISPLAY_NAME,
  MAPPING_FIELD_NAMES.MOS_EXTRACTED_FIELD_NAME,
  MAPPING_FIELD_NAMES.MOS_TENANT_FIELD_DISPLAY_NAME,
  MAPPING_FIELD_NAMES.SOURCE_FIELD_ID,
  MAPPING_FIELD_NAMES.MOS_EXTERNAL_FIELD_NAME,
] as const;

export const SCOPE_VALUES = ['borrower', 'common'] as const;

/** Built-in systems selectable in the Source column. */
export enum MappingSource {
  Encompass = 'Encompass',
  EncompassCustomFields = 'Encompass - Custom Fields',
  MOS = 'MOS',
  ULDD = 'ULDD',
}

/** Values shown in the Source column. */
export const SOURCE_VALUES = [
  MappingSource.Encompass,
  MappingSource.EncompassCustomFields,
  MappingSource.MOS,
  MappingSource.ULDD,
] as const;

/** Placeholder MOS source field ids until an API exists. */
export const MOS_SOURCE_FIELD_IDS = ['Field1', 'Field2', 'Field3'] as const;

/** Dropdown includes blank for new rows before a source is chosen. */
export const SOURCE_DROPDOWN_VALUES = ['', ...SOURCE_VALUES] as const;

export const LOADING_FIELDS_TEXT = 'Loading fields...';
export const NO_FIELDS_AVAILABLE_TEXT = 'No fields available';
